import React, {createContext, useReducer} from 'react'

export const SET_DEVICE_LIST = 'SET_DEVICE_LIST'
export const SELECT_DEVICE = 'SELECT_DEVICE'
export const SET_SHOW_DEVICE_POPUP = 'SET_SHOW_DEVICE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_DEVICE_LIST:
      return { ...data, device_list: payload.data }
    case SELECT_DEVICE:
      return {
        ...data,
        selected_device: payload.data.selected_device,
        show_device_popup: payload.data.show_device_popup,
      }
    case SET_SHOW_DEVICE_POPUP:
      return {
        ...data,
        show_device_popup: payload.data,
        selected_device: payload.data ? data.selected_device : {},
      }
    default:
      return data
  }
}

const initialState = {
  device_list: [],
  selected_device: {},
  show_device_popup: false,
}

const DeviceStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <DeviceContext.Provider value={[state, dispatch]}>
      {children}
    </DeviceContext.Provider>
  )
}

export const DeviceContext = createContext(initialState)
export default DeviceStore
